import React from 'react';
import { Button, Card, Icon, Modal } from 'semantic-ui-react';
import { copy, showSuccess, showWarning } from '../../helpers';
import ModelBrandIconV10 from './ModelBrandIconV10';

export const OtherModelCardV109 = ({ item, text, onContact }) => (
  <Card className='other-model-card-v109' data-model={item.model_name}>
    <Card.Content>
      <div className='other-model-identity-v109'>
        <ModelBrandIconV10 brand={item.presentation.brand} />
        <h2>{item.model_name}</h2>
      </div>
      <div className='other-model-status-v109'>
        <Icon name='lock' />
        {text.unavailable}
      </div>
      <p>{text.cardDescription}</p>
      <Button basic onClick={() => onContact(item.model_name)}>
        <Icon name='comment alternate outline' />
        {text.inquiry}
      </Button>
    </Card.Content>
  </Card>
);

export const ModelContactV109 = ({
  model,
  contact,
  text,
  closeLabel,
  onClose,
}) => {
  const inquiry = text.inquiryText(model);
  const copyInquiry = async () => {
    try {
      if (await copy(inquiry)) showSuccess(text.copied);
      else showWarning(text.copyFailed);
    } catch (_) {
      showWarning(text.copyFailed);
    }
  };
  return (
    <Modal
      open={model !== null}
      onClose={onClose}
      size='small'
      className='model-contact-v109'
      aria-label={text.contact}
    >
      <Modal.Header>{text.contact}</Modal.Header>
      <Modal.Content>
        <p className='model-contact-address-v109'>
          {contact || text.contactFallback}
        </p>
        <p>{text.contactNote}</p>
        <blockquote>{inquiry}</blockquote>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose}>{closeLabel}</Button>
        <Button primary onClick={copyInquiry}>
          <Icon name='copy outline' />
          {text.copyInquiry}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
